import React from 'react'
import {Modal} from 'react-bootstrap'
import {useIntl} from 'react-intl'
import {MARKET_PROMO_AMOUNT} from '../../../../_gori/constants/_const'

type Props = {
  show: boolean
  handleClose: () => void
}

const TermsModal: React.FC<Props> = ({show, handleClose}) => {
  const intl = useIntl()
  return (
    <Modal show={show} onHide={handleClose} centered dialogClassName='terms-modal'>
      <div className='terms-container'>
        {/* Header */}
        <div className='terms-header'>
          <div className='title-container'>
            <div className='title'>
              {intl.formatMessage({id: 'MARKETPLACE_PROMOTION_TERMS_TITLE'})}
            </div>
            <div className='date'>
              {intl.formatMessage({id: 'MARKETPLACE_PROMOTION_TERMS_DATE'})}
            </div>
          </div>
          <button className='close-button' onClick={handleClose} aria-label='Close'>
            ×
          </button>
        </div>

        {/* Body */}
        <div className='terms-body'>
          <div className='content-outer'>
            <div className='content-middle'>
              <div className='content-inner'>
                <div className='intro-text'>
                  {intl.formatMessage({id: 'MARKETPLACE_PROMOTION_TERMS_AGREEMENT_TEXT'})}
                </div>

                <div className='section'>
                  <span className='section-text'>
                    {intl.formatMessage({id: 'MARKETPLACE_PROMOTION_TERMS_SUBTITLE_1'})}
                    <br />
                    <ul>
                      <li>{intl.formatMessage({id: 'MARKETPLACE_PROMOTION_TERMS_TEXT_1'})}</li>
                      <li>{intl.formatMessage({id: 'MARKETPLACE_PROMOTION_TERMS_TEXT_2'})}</li>
                      <li>{intl.formatMessage({id: 'MARKETPLACE_PROMOTION_TERMS_TEXT_3'})}</li>
                    </ul>
                  </span>
                </div>

                <div className='section'>
                  <span className='section-text'>
                    {intl.formatMessage({id: 'MARKETPLACE_PROMOTION_TERMS_SUBTITLE_2'})}
                    <br />
                    <ul>
                      <li>
                        {intl.formatMessage(
                          {id: 'MARKETPLACE_PROMOTION_TERMS_TEXT_4'},
                          {amount: MARKET_PROMO_AMOUNT}
                        )}
                      </li>
                    </ul>
                  </span>
                </div>

                <div className='section'>
                  <span className='section-text'>
                    {intl.formatMessage({id: 'MARKETPLACE_PROMOTION_TERMS_SUBTITLE_3'})}
                    <br />
                    <ul>
                      <li>{intl.formatMessage({id: 'MARKETPLACE_PROMOTION_TERMS_TEXT_5'})}</li>
                      <li>{intl.formatMessage({id: 'MARKETPLACE_PROMOTION_TERMS_TEXT_6'})}</li>
                    </ul>
                  </span>
                </div>

                <div className='section'>
                  <span className='section-text'>
                    {intl.formatMessage({id: 'MARKETPLACE_PROMOTION_TERMS_SUBTITLE_4'})}
                    <br />
                    <ul>
                      <li>{intl.formatMessage({id: 'MARKETPLACE_PROMOTION_TERMS_TEXT_7'})}</li>
                      <li>{intl.formatMessage({id: 'MARKETPLACE_PROMOTION_TERMS_TEXT_8'})}</li>
                      <li>{intl.formatMessage({id: 'MARKETPLACE_PROMOTION_TERMS_TEXT_9'})}</li>
                    </ul>
                  </span>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Footer */}
        <div className='terms-footer'>
          <div className='button-container'>
            <button className='btn btn-advanced-secondary' onClick={handleClose}>
              <div className='button-text'>Close</div>
            </button>
          </div>
        </div>
      </div>
    </Modal>
  )
}

export {TermsModal}
